import React from "react";
import Icon from "@mdi/react";
import { mdiPower, mdiPowerOff } from "@mdi/js";

type IconActiveProps = {
  isActive: number;
  size?: number;
};

const IconActive: React.FC<IconActiveProps> = ({ isActive = 1, size = 1 }) => {

  return (<>{isActive === 1 ?
    (<Icon path={mdiPower} size={size} color={"green"} />)
    :
    (<Icon path={mdiPowerOff} size={size} color={"lightgrey"} />)
  }
  </>)
}
export default IconActive;
